import { useControlledSwr } from 'shared/hooks/use-controlled-swr'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import { RequestModuleEnum } from 'shared/enums/request-module-enum'
import { WebsiteInterface } from '../types/website-interface'
import { WEBSITE_API } from '../api/website-api'

interface WebsiteListItemInterface extends Pick<WebsiteInterface, 'name' | 'id'> {}

export function useWebsiteListAll(shouldFetch: boolean = true) {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, WebsiteListItemInterface[]>({
    method: RequestMethodsEnum.get,
  })

  const { data: websiteListAll, mutate } = useControlledSwr(
    [`${WEBSITE_API}/websites/list-all`, RequestModuleEnum.Websites],
    fetcher,
    undefined,
    shouldFetch && !!user,
  )

  return { websiteListAll, mutate }
}
